import React from 'react';
import Distance from '../Distance';
import Text from '../../styled/Text';
import AnimateContentHeight from '../AnimateContentHeight';
import LinkButton from '../LinkButton';

import { CertificationContent, ContentWrapper } from './wrappers';
import clsx from 'clsx';
import { Image } from '../Image';
import ImageBox from '../ImageBox';
import HtmlContent from '../../components-legacy/HtmlContent';

export interface ICertificationDetails {
  image: string;
  title: string;
  subtitle: string;
  description: string;
  licensenumber: string;
  extended: boolean;
  onToggle: () => void;
}

const CertificationDetails = ({
  image,
  title,
  subtitle,
  description,
  licensenumber,
  extended,
  onToggle,
}: ICertificationDetails) => (
  <>
    <CertificationContent>
      <ImageBox height="80px" width="80px">
        <Image widthAuto src={image} />
      </ImageBox>
      <ContentWrapper>
        <Text weight="medium">{title}</Text>
        <Distance size="1" />
        <Text tone="ghost" size="small">
          {subtitle}
        </Text>
        <Distance size="1" />
        <LinkButton onClick={onToggle} className={clsx(extended && 'not-visable')}>
          Visa mer
        </LinkButton>
      </ContentWrapper>
    </CertificationContent>
    <AnimateContentHeight open={extended}>
      <Distance size="2" />
      <HtmlContent markdown={description} style={{ fontSize: '16px', lineHeight: '1.5' }} />
      <Distance size="2" />
      {licensenumber && (
        <Text tone="ghost" size="small">
          Licensnummer: {licensenumber}
        </Text>
      )}
      <Distance size="2" />
      <LinkButton onClick={onToggle}>Visa mindre</LinkButton>
    </AnimateContentHeight>
  </>
);

export default CertificationDetails;
